import styled, { css } from 'styled-components';
import { GEL_SPACING, GEL_SPACING_DBL } from '@bbc/gel-foundations/spacings';
import { GEL_GROUP_3_SCREEN_WIDTH_MIN, GEL_GROUP_3_SCREEN_WIDTH_MAX, GEL_GROUP_4_SCREEN_WIDTH_MIN, GEL_GROUP_5_SCREEN_WIDTH_MIN } from '@bbc/gel-foundations/breakpoints';
import { grid } from '@bbc/psammead-styles/detection';
var twoOfSixColumnsMaxWidthScaleable = "33.33%"; // (2 / 6) * 100 = 0.3333333333 = 33.33%

var fourOfSixColumnsMaxWidthScaleable = "66.67%"; // (4 / 6) * 100 = 66.6666666667 = 66.67%

var fullWidthColumnsMaxScaleable = "100%"; // (12 / 12) * 100 = 100 = 100%

var halfWidthColumnsMaxScaleable = "50%";

var paddingDir = function paddingDir(_ref) {
  var dir = _ref.dir;
  return "padding-".concat(dir === 'rtl' ? 'left' : 'right');
};

var TextGridColumnsTopStory = /*#__PURE__*/css(["grid-column:1 / span 6;@media (min-width:", "){grid-column:4 / span 3;}@media (min-width:", "){grid-column:7 / span 6;}"], GEL_GROUP_3_SCREEN_WIDTH_MIN, GEL_GROUP_5_SCREEN_WIDTH_MIN);
var TextGridColumns = /*#__PURE__*/css(["grid-column:3 / span 4;", " @media (min-width:", "){padding-top:", "}"], function (_ref2) {
  var displayImage = _ref2.displayImage;
  return !displayImage && "grid-column: 1 / span 6;";
}, GEL_GROUP_4_SCREEN_WIDTH_MIN, function (_ref3) {
  var displayImage = _ref3.displayImage;
  return displayImage ? GEL_SPACING : '0';
});
var TextGridColumnsLeadingStory = /*#__PURE__*/css(["padding:0;width:100%;grid-template-columns:repeat(6,1fr);grid-column-end:span 6;@media (min-width:", "){grid-template-columns:repeat(3,1fr);grid-column-end:span 3;}@media (min-width:", "){grid-template-columns:repeat(2,1fr);grid-column-end:span 2;}"], GEL_GROUP_3_SCREEN_WIDTH_MIN, GEL_GROUP_4_SCREEN_WIDTH_MIN);
var TextGridFallbackTopStory = /*#__PURE__*/css(["@media (min-width:", "){width:", ";padding:0 ", ";}@media (min-width:", "){width:", ";}"], GEL_GROUP_3_SCREEN_WIDTH_MIN, halfWidthColumnsMaxScaleable, GEL_SPACING_DBL, GEL_GROUP_4_SCREEN_WIDTH_MIN, halfWidthColumnsMaxScaleable);
var TextGridFallback = /*#__PURE__*/css(["width:", ";padding:0 ", ";@media (min-width:", "){padding:0 ", ";}@media (min-width:", "){display:block;width:100%;padding:", " 0;}", ""], fourOfSixColumnsMaxWidthScaleable, GEL_SPACING, GEL_GROUP_3_SCREEN_WIDTH_MIN, GEL_SPACING_DBL, GEL_GROUP_4_SCREEN_WIDTH_MIN, GEL_SPACING, function (_ref4) {
  var displayImage = _ref4.displayImage;
  return !displayImage && "width: ".concat(fullWidthColumnsMaxScaleable, "; >div{ vertical-align: middle; }");
});
var TextGridFallBackLeadingStory = /*#__PURE__*/css(["width:", ";@media (min-width:", "){", ":", ";width:", ";}@media (min-width:", "){width:", ";}"], fullWidthColumnsMaxScaleable, GEL_GROUP_3_SCREEN_WIDTH_MIN, paddingDir, GEL_SPACING, halfWidthColumnsMaxScaleable, GEL_GROUP_4_SCREEN_WIDTH_MIN, twoOfSixColumnsMaxWidthScaleable);
var textGridFallbackStyles = {
  top: TextGridFallbackTopStory,
  regular: TextGridFallback,
  leading: TextGridFallBackLeadingStory
};
var textGridStyles = {
  top: TextGridColumnsTopStory,
  regular: TextGridColumns,
  leading: TextGridColumnsLeadingStory
}; // This applies 8px padding only to the timestamp.
// The headline already has padding so targeting the timestamp prevents double padding
// from being applied.

var leadingPromoTimestampPadding = "\n  >time {\n    @media (max-width: ".concat(GEL_GROUP_3_SCREEN_WIDTH_MAX, ") {\n      padding-bottom: ").concat(GEL_SPACING, ";\n    }\n  }\n");
var TextGridItem = /*#__PURE__*/styled.div.withConfig({
  displayName: "TextGridItem",
  componentId: "sc-1lkbq5i-0"
})(["display:inline-block;vertical-align:top;", " @supports (", "){display:block;width:initial;padding:initial;", "}", " ", ""], function (_ref5) {
  var promoType = _ref5.promoType;
  return textGridFallbackStyles[promoType];
}, grid, function (_ref6) {
  var promoType = _ref6.promoType;
  return textGridStyles[promoType];
}, function (_ref7) {
  var promoType = _ref7.promoType;
  return promoType === 'leading' && leadingPromoTimestampPadding;
}, function (_ref8) {
  var displayImage = _ref8.displayImage;
  return !displayImage && ">div{ display:inline-block; vertical-align:initial; }\n       & svg{ margin: 0; }";
});
export default TextGridItem;